function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.465 269.291"
}, props), /*#__PURE__*/React.createElement("ellipse", {
  cx: "103.124",
  cy: "102.697",
  rx: "18.004",
  ry: "17.699"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "180.441",
  cy: "102.697",
  rx: "18.004",
  ry: "17.699"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.732 0C63.515 0 0 41.899 0 134.596S63.515 269.29 141.732 269.29s141.733-41.898 141.733-134.695S220.05 0 141.732 0zM60.014 53.998c19.504-16.8 47.81-25.699 81.718-25.699s62.215 8.9 81.719 25.7c21.005 18.099 31.707 45.198 31.707 80.597q0 3.452-.136 6.797H202.95v.047l-61.217-20.968-61.08 20.92h-52.11q-.135-3.346-.138-6.796c0-35.4 10.603-62.498 31.608-80.598zM92.203 220.66v-53.098l49.53-16.964 49.53 16.964v53.098c-14.11 12.621-31.487 19.56-49.53 19.68-18.044-.12-35.422-7.059-49.53-19.68zm-59.59-50.766h31.09v48.282q-1.893-1.447-3.69-2.982c-13.363-11.515-22.51-26.68-27.4-45.3zm190.838 45.3q-1.794 1.546-3.689 2.999v-48.3h31.185c-4.9 18.621-14.069 33.786-27.496 45.301z"
})));